/**
 * @module store/points/mutations
 *
 * @version 1.0.0
 * @copyright SBC 2019
 */


import * as types from '@/store/mutation-types';

/* eslint-disable no-param-reassign */
export default {
  /**
   * Mutation: Задание списка точек на карте
   *
   * @since Version 1.0.0
   */
  [types.SET_PROMOS](state, promos) {
    state.promos = promos;
  },
};
/* eslint-enable no-param-reassign */
